import React from 'react'
import About from '../components/About/About'
import BackToTop from '../components/BackToTop'
import Footer from '../components/Footer/Footer'
// import GoToTop from '../components/GoToTop'

import BookingSection from '../components/BookingSection'
import BlogList from "../components/BlogList";





import Achievement from '../components/Achievements/Achievement'
import Client from '../components/ClientTestimonial.js/Client'
import Carousel from '../components/Header/Carousel'
import Partner from '../components/Partner/Partner'
import Services from '../components/Service/Service'



import FundersStrip from '../components/FundersStrip';
//import Header from '../components/Header/Header'


const Home = () => {
  document.title = "IQApex Labs | IT Company | Software Development | We Are Think-Tank"
  
  return (
    <>
    {/* <GoToTop /> */}
      
      <Carousel/>
      <About />
      <Services />
      {/* <Product /> */}


      <BookingSection />
        <BlogList />
      <Achievement/>
      {/* <Testimonial /> */}

       {/* ✅ Add Funders Section Here */}
      <FundersStrip />
      

      <Partner />
      <Client />      
      <BackToTop/>
      <Footer />
    </>
  )
}

export default Home
